import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import List from "components/sessions/List";
import Create from "components/sessions/Create";
import Import from "components/sessions/Import";
export default function ManageSessions() {
    return (_jsxs("div", { className: "p-4", children: [_jsx("h1", { className: "header-1", children: "Your Sessions" }), _jsx("div", { className: "my-4", children: _jsx(List, {}) }), _jsxs("div", { className: "mt-4 flex items-center gap-4", children: [_jsx(Import, {}), _jsx(Create, {})] })] }));
}
